import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-modal");
import { globalStyle, style } from '@vanilla-extract/css';
import { tokens, breakpoints } from '@paypalcorp/pp-react-theme';
import { ZINDEX_MODAL } from '@paypalcorp/pp-react-utils';
import { elevationStyles } from '@paypalcorp/pp-react-elevation';
import { textStyles } from '@paypalcorp/pp-react-text';
const modalHeaderMinHeight = tokens.space['800'];
const modalHeaderZoneMinWidth = tokens.size.icon.lg;
const sheetButtonSize = `calc(${tokens.size.icon.sm} + ${tokens.space['300']})`;
const MEDIA_QUERY_LG_MAX = `screen and (max-width: ${breakpoints.mediaLg})`;
const MEDIA_QUERY_MD_MAX = `screen and (max-width: ${breakpoints.mediaMd})`;
const MEDIA_QUERY_MD_MIN = `screen and (min-width: ${breakpoints.mediaMd})`;
const textCenter = {
  textAlign: 'center'
};
const textRight = {
  textAlign: 'right'
};
const borderTopRadii = {
  borderTopLeftRadius: tokens.border.radius.jumbo,
  borderTopRightRadius: tokens.border.radius.jumbo
};
const containerCenter = (alignment = 'center') => {
  return style({
    display: 'flex',
    alignItems: alignment,
    justifyContent: 'space-around'
  }, `modal-container_center_${alignment}`);
};
const base = style([elevationStyles.level3, {
  backgroundColor: tokens.color.background.surface,
  display: 'grid',
  gridTemplateRows: 'auto 1fr auto',
  position: 'relative',
  flexBasis: '100%'
}], 'modal-base');
const modalBackdrop = style([containerCenter('center'), {
  position: 'fixed',
  inset: 0,
  zIndex: ZINDEX_MODAL,
  visibility: 'hidden',
  opacity: 0,
  willChange: 'opacity',
  transition: `opacity ${tokens.motion.duration.depart} ease-in-out,
    visibility ${tokens.motion.duration.depart} ${tokens.motion.duration.depart}`,
  backgroundColor: tokens.color.overlay.mainHover,
  boxShadow: 'none'
}], 'modal_backdrop');
globalStyle(`${modalBackdrop} [aria-hidden="false"], ${modalBackdrop} [aria-hidden="true"]`, {
  transitionDuration: tokens.motion.duration.arrive
});
const modalContents = style([textStyles.bodyStyles, {
  flex: '1 1 auto',
  overflow: 'auto',
  position: 'relative',
  borderRadius: 'inherit',
  '@media': {
    [MEDIA_QUERY_MD_MAX]: {
      padding: `0 ${tokens.space['300']} ${tokens.space['300']}`
    }
  }
}], 'modal-contents');
const modalContentsNoPadding = style({
  selectors: {
    [`${modalContents}&`]: {
      padding: 0,
      '@media': {
        [MEDIA_QUERY_LG_MAX]: {
          padding: '0'
        },
        [MEDIA_QUERY_MD_MAX]: {
          padding: 0
        }
      }
    }
  }
}, 'modal-content_no_padding');
const modalContentsCenter = style(textCenter, 'modal-content_center');
const modalHeader = style({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  position: 'relative',
  flex: '0 0 auto',
  zIndex: 1,
  minHeight: modalHeaderMinHeight,
  padding: tokens.space['150'],
  '@media': {
    [MEDIA_QUERY_MD_MAX]: borderTopRadii
  }
}, 'modal-header');
const modalHeaderScrolled = style([elevationStyles.level3, {
  '@media': {
    [MEDIA_QUERY_MD_MAX]: borderTopRadii
  }
}], 'modal-header_scrolled');
const modalHeaderAction = style({
  flex: `0 0 ${modalHeaderZoneMinWidth}`,
  flexBasis: sheetButtonSize
}, 'modal-header_action');
const modalHeaderTitle = style([textStyles.body, {
  flex: '1 1 3rem',
  margin: tokens.space['100'],
  ...textCenter
}], 'modal-header_title');
const modalHeaderClose = style({
  flex: `0 0 ${modalHeaderZoneMinWidth}`,
  flexBasis: sheetButtonSize,
  ...textRight
}, 'modal-header_close');
const modalHeaderLogo = style({
  display: 'flex',
  flex: '1 1 3rem',
  justifyContent: 'center',
  marginTop: tokens.space['100']
}, 'modal-header_logo');
const modalHeaderLogoImage = style({
  width: tokens.size.icon.md,
  height: tokens.size.icon.md
}, 'modal-header_logo_image');
const modalContentsClose = style({
  position: 'absolute',
  right: tokens.space['50'],
  top: tokens.space['50'],
  zIndex: 2,
  selectors: {
    '[dir="rtl"] &': {
      left: tokens.space['50'],
      right: 'auto',
      '@media': {
        [MEDIA_QUERY_MD_MIN]: {
          left: tokens.size.indicator.md
        }
      }
    }
  }
}, 'modal-content_close');
globalStyle(`${modalContentsClose}`, {
  '@media': {
    [MEDIA_QUERY_MD_MIN]: {
      right: tokens.size.indicator.md,
      top: tokens.space['150']
    }
  }
});
const modalFooter = style({
  minHeight: modalHeaderMinHeight,
  padding: tokens.space['200'],
  position: 'relative',
  flex: '1 0 auto'
}, 'modal-footer');
const modalFooterScrolled = style([elevationStyles.level3, {
  borderBottomLeftRadius: 'inherit',
  borderBottomRightRadius: 'inherit'
}], 'modal-footer_scrolled');
const modalFooterAlignCenter = style({
  display: 'flex',
  justifyContent: 'center'
}, 'modal-footer_align_center');
const modalFooterAlignRight = style({
  display: 'flex',
  justifyContent: 'end'
}, 'modal-footer_align_right');
export { base, modalContents, modalContentsNoPadding, modalContentsCenter, modalHeader, modalHeaderScrolled, modalHeaderClose, modalHeaderAction, modalHeaderTitle, modalHeaderLogo, modalHeaderLogoImage, modalFooter, modalFooterScrolled, modalFooterAlignCenter, modalFooterAlignRight };
__vanilla_filescope__.endFileScope();
